import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    status: require('./status').default,
    auth: require('./auth').default,
    env: require('./env').default,
    ui: require('./ui').default,
    filter: require('./filter').default,
    loan: require('./loan').default,
    loading: require('./loading').default,
    delivery: require('./delivery').default,
    talks: require('./talks').default,
  },
  plugins: [
    createPersistedState({
      paths: ['talks'],
    })
  ]
})
